// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// Yeni FE deploy sonrası tarayıcı, sunucudan SİLİNMİŞ eski chunk hash'ini ister →
// dinamik import 404. Tarayıcıya göre mesaj değişir:
//   Chrome/Edge: "Failed to fetch dynamically imported module"
//   Safari:      "Importing a module script failed"
//   Firefox:     "error loading dynamically imported module"
// Tek-sefer otomatik reload ile güncel index.html + chunk'lar çekilir. TÜM tarayıcılarda çalışsın diye
// üç kanal dinlenir (Vite preload event + window error + unhandledrejection). Sonsuz döngü 10sn guard ile önlenir.

const RELOAD_KEY = 'elpo:lastChunkReload';
const GUARD_MS = 10_000;

function reloadOnce(): void {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? '0');
    if (Date.now() - last < GUARD_MS) {
      return; // yakın zamanda reload edildi → döngü engeli (chunk gerçekten yoksa kullanıcıyı kasmaz)
    }
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage erişilemezse (gizli mod / cookie kapalı) yine de bir kez dene
  }
  window.location.reload();
}

function isChunkLoadError(message: string | null | undefined): boolean {
  if (!message) {
    return false;
  }
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError|Failed to fetch dynamically/i
    .test(message);
}

/** Eski-chunk 404'ünde otomatik tazeleme bekçisini kur (main.tsx render'dan önce çağrılır). */
export function installChunkReloadGuard(): void {
  // Vite dinamik import preload helper'ı başarısız olunca
  window.addEventListener('vite:preloadError', (event: Event) => {
    event.preventDefault();
    reloadOnce();
  });

  // Genel kaynak/script yükleme hatası
  window.addEventListener('error', (event: ErrorEvent) => {
    if (isChunkLoadError(event?.message)) {
      reloadOnce();
    }
  });

  // Yakalanmamış promise reddi — React.lazy import reddi buraya düşer
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const reason = event?.reason as unknown;
    const message = typeof reason === 'string' ? reason : (reason as { message?: string } | null)?.message;
    if (isChunkLoadError(message)) {
      reloadOnce();
    }
  });
}
